require('./catalog-search.component.scss');

class CatalogSearchController {
  constructor(
    CurrentFilterService,
    LayoutService,
    FiltersService,
    CatalogNodeDragService,
  ) {
    // this.drag = CatalogNodeDragService;
    this.layout = LayoutService;
    this.currentFilter = CurrentFilterService;
    this.FiltersService = FiltersService;
    // this.value = '';
    this.previousValue = '-';
    this.searchFilters();
  }

  searchKeyup(event) {
    if (event.keyCode === 13) {
      this.searchFilters();
    }
  }

  searchClean() {
    this.layout.searchTrim = '';
    this.currentFilter.FiltersService.searchFiltersTrim();
  }

  searchFilters() {
    if (this.layout.searchTrim === undefined || this.layout.searchTrim === this.previousValue) return;
    this.previousValue = this.layout.searchTrim;
    this.currentFilter.FiltersService.searchFiltersTrim(this.layout.searchTrim);
    // if (this.layout.searchTrim) {
    //   const searchTrim = this.layout.searchTrim.toLowerCase();
    // } else this.currentFilter.FiltersService.searchFilters();
  }
}


export const CatalogSearchComponent = {
  template: require('./catalog-search.component.html'),
  bindings: {},
  controller: CatalogSearchController,
};



// WEBPACK FOOTER //
// ./src/filter/catalog/catalog-search.component.js